export class MerchantTourService {
  initUser(
    userId: string
  ): Promise<{ hasSeenTour: boolean; showTooltip: boolean }> {
    return new Promise((resolve) => {
      const userTourData = this.getUserTourData(userId)
      if (!userTourData) {
        this.createUser(userId)
        return resolve({ hasSeenTour: false, showTooltip: true })
      }

      const { hasSeenTour = false, tourSkippedCount = 0 } = userTourData
      resolve({ hasSeenTour, showTooltip: tourSkippedCount < 1 })
    })
  }

  markTourAsSeen(userId: string): Promise<void> {
    return new Promise((resolve) => {
      const userTourData = this.getUserTourData(userId) || {}
      userTourData.hasSeenTour = true
      this.saveUserTourData(userId, userTourData)
      resolve()
    })
  }

  skipTour(userId: string, step?: number): Promise<void> {
    return new Promise((resolve) => {
      const userTourData = this.getUserTourData(userId) || {}
      userTourData.tourSkippedCount = (userTourData.tourSkippedCount || 0) + 1
      userTourData.tourSkippedStep = step
      this.saveUserTourData(userId, userTourData)
      resolve()
    })
  }

  public getUserTourData(userId: string): any {
    const value = localStorage.getItem(`user_${userId}`)
    return value ? JSON.parse(value) : undefined
  }

  private saveUserTourData(userId: string, data: any): void {
    localStorage.setItem(`user_${userId}`, JSON.stringify(data))
  }

  private createUser(userId: string): void {
    const userTourData = { hasSeenTour: false, tourSkippedCount: 0 }
    this.saveUserTourData(userId, userTourData)
  }
}
